module.exports = __webpack_public_path__ + "media/icons/resq_small-de66947a.png";